import React from 'react';
import styles from './styles.css';
import warning from './warning.png';

export default () =>
<div className='empty-list'>
  <img className='empty-list__img' src={warning} />
  <div className='empty-list__txt'>Nenhum dado encontrado</div>
</div>;



// WEBPACK FOOTER //
// ./src/components/emptyList/EmptyList.js